"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function compareArrays(array1, array2) {
    return !!array1 && !!array2 &&
        Array.isArray(array1) && Array.isArray(array2) &&
        (array1.length === array2.length) &&
        array1.every(function (elem, index) {
            return elem === array2[index];
        });
}
exports.compareArrays = compareArrays;
;
/**
 * Normalizes various data types to a consistent JavaScript array format.
 * Handles Immutable Lists, plain arrays, and null/undefined values.
 * @param value - Immutable List, plain array, or other value to normalize
 * @returns Plain JavaScript array
 */
function normalizeToArray(value) {
    if (!value)
        return [];
    return value.toArray ? value.toArray() : (Array.isArray(value) ? value : []);
}
exports.normalizeToArray = normalizeToArray;
//# sourceMappingURL=array-extensions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/utilities/array-extensions.js
// module id = 1106
// module chunks = 0